import React from "react";
import { Package, Shield, Truck, FileText, Globe, Clock, FileCheck, Layers, Cpu } from "lucide-react";

const valueCards = [
  {
    id: 1,
    icon: "FileText",
    title: "1-Click Export Documentation",
    description:
      "Instant generation of Quotation Documents, Commercial Invoices, Certificates of Origin, and Customs Packing Lists.",
  },
  {
    id: 2,
    icon: "Package",
    title: "Ceramic Tile Inventory Control",
    description:
      "Track ceramic tile dimensions, body absorption, box coverage ratios, weight specifications, and SKU master lists.",
  },
  {
    id: 3,
    icon: "Shield",
    title: "Incoterm & Freight Rules",
    description:
      "Automated FOB, CIF, and CNF price calculations with dynamic ocean freight and marine insurance charge adjustments.",
  },
  {
    id: 4,
    icon: "Globe",
    title: "International Port Directory",
    description:
      "Integrated master directory covering 200+ global shipping ports, destination rules, and multi-currency exchange rates.",
  },
  {
    id: 5,
    icon: "Layers",
    title: "Audit Log & Version History",
    description:
      "Complete track record of revision history, snapshot field changes, and staff action logs for full accountability.",
  },
  {
    id: 6,
    icon: "Clock",
    title: "Real-Time Container Tracking",
    description:
      "Monitor vessel voyage numbers, port of loading, BL draft approvals, and dispatch schedules with zero delay.",
  },
];

const getIcon = (iconName) => {
  const icons = { FileText, Shield, Truck, Globe, Package, Clock, FileCheck, Layers, Cpu };
  return icons[iconName] || Package;
};

export const ValueCards = () => {
  return (
    <section id="features" className="bg-slate-50/70 py-20 border-b border-slate-200 text-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-3 mb-14">
          <p className="text-xs font-bold uppercase tracking-widest text-amber-700">
            Enterprise Module Architecture
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
            Everything You Need For Seamless Global Exports
          </h2>
          <p className="text-sm text-slate-600 max-w-2xl mx-auto">
            Built specifically to eliminate trade compliance bottlenecks and manual spreadsheet errors.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {valueCards.map((card) => {
            const Icon = getIcon(card.icon);
            return (
              <div
                key={card.id}
                className="bg-white border border-slate-200/90 hover:border-amber-400 rounded-2xl p-6 shadow-sm hover:shadow-md hover:scale-[1.01] transition-all duration-200 group cursor-pointer"
              >
                <div className="w-12 h-12 bg-amber-100/80 border border-amber-200 rounded-xl flex items-center justify-center mb-5 group-hover:bg-amber-600 group-hover:text-white text-amber-800 transition-colors">
                  <Icon className="w-6 h-6 transition-colors" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-amber-700 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs text-slate-600 leading-relaxed font-normal">
                  {card.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueCards;
